import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { CONFIG } from '../../environments/config';

@Injectable({ providedIn: 'root' })
export class RFQService {

  constructor(private httpClientService: HttpClientService) { }


  public checkRfqCode(data: any) {
    return this.httpClientService.get(`${CONFIG.RFQ.CHECK_RFQ_CODE}?RfqCode=${data}`);
  }

  public autogenerateRfqCode() {
    return this.httpClientService.get(CONFIG.RFQ.AUTOGENERATE_RFQCODE);
  }

  public createRFQ(data: any) {
    return this.httpClientService.post(`${CONFIG.RFQ.CREATE_RFQ}`, data);
  }

  public createRFQVendors(data: any) {
    return this.httpClientService.post(`${CONFIG.RFQ.CREATE_RFQ_VENDORS}`, data);
  }

  public createRFQProducts(data: any) {
    return this.httpClientService.post(`${CONFIG.RFQ.CREATE_RFQ_PRODUCTS}`, data);
  }

  public getRFQList(data: any) {
    return this.httpClientService.post(CONFIG.RFQ.RFQ_LIST, data);
  }

  public updateRFQ(data: any) {
    return this.httpClientService.post(CONFIG.RFQ.UPDATE_RFQ, data);
  }

   public deleteRFQ(data: any) {
    return this.httpClientService.post(`${CONFIG.RFQ.DELETE_RFQ}`, data);
  }

  public getRFQById(rfqId: number) {
    return this.httpClientService.get(`${CONFIG.RFQ.GET_RFQ_BY_ID}?id=${rfqId}`);
  }

  public updateRFQVendors(data: any) {
    return this.httpClientService.post(`${CONFIG.RFQ.UPDATE_RFQ_VENDORS}`, data);
  }

  public updateRFQProducts(data: any) {
    return this.httpClientService.post(`${CONFIG.RFQ.UPDATE_RFQ_PRODUCTS}`, data);
  }

  public deleteRFQVendor(rfqVendorId: number) {
    return this.httpClientService.post(`${CONFIG.RFQ.DELETE_RFQ_VENDOR}`, { rfqVendorId });
  }

  public deleteRFQProduct(rfqProductId: number) {
    return this.httpClientService.post(`${CONFIG.RFQ.DELETE_RFQ_PRODUCT}`, { rfqProductId });
  }

  public SearchRfq(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.RFQ.SEARCHRFQ}?searchText=${seachkey}`);
  }


}
